import PropTypes from 'prop-types';
import React, { Component } from 'react';
import DateRangePicker from 'react-daterange-picker';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
  HelpBlock,
} from 'react-bootstrap';
import moment from 'moment';

class DateRangePickerWithYearMonthNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      focusedInput: null,
      isOpen: false,
      value: moment.range(this.props[this.props.startDateFieldName].input.value, this.props[this.props.endDateFieldName].input.value),
      isStay: props.isStay
    };
    this.onRangeSelect = this.onRangeSelect.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  componentWillMount(){
    document.addEventListener('mousedown', this.handleClick, false);
  }
  componentWillUnmount(){
    document.addEventListener('mousedown', this.handleClick, false);
  }
  handleClick = (e) => {
    if(this.node.contains(e.target) || e.target.id == "eventDateRange"){
      return;
    }
    this.handleClickOutside();
  }
  handleClickOutside(){
    this.setState({
      isOpen: !this.state.isOpen
    })
  }
  handleToggleCalendar = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };
  onRangeSelect = (value, states) => {
    this.setState({ value, states });
    const startField = this.props[this.props.startDateFieldName];
    const endField = this.props[this.props.endDateFieldName];
    startField.input.onChange(value.start);
    endField.input.onChange(value.end);
    this.setState({
      isOpen: false
    })
  };

  render() {
    const startDate = this.props[this.props.startDateFieldName].input.value || null;
    const endDate = this.props[this.props.endDateFieldName].input.value || null;
    const value = moment.range(startDate, endDate)

    return (
      <div>
        <div id="eventDateRange" onClick={this.handleToggleCalendar}>
          {value.start.format("MM/DD/YYYY")}
          {" - "}
          {value.end.format("MM/DD/YYYY")}
        </div>
          {this.state.isOpen &&
            (<div className="date-range-picker-section" ref={node => this.node = node}>
                <DateRangePicker
                  numberOfCalendars = {2}
                  value = {value}
                  onSelect={this.onRangeSelect}
                  singleDateRange={true}
                  minimumDate={this.state.isStay ? null : moment(moment.now()).add(1,'days')}
                  showLegend={true}
                  selectedLabel=" Click on month/year to select month/year quickly"
                />
            </div>)}
      </div>
    );
  }
}
export default DateRangePickerWithYearMonthNavigation;



// WEBPACK FOOTER //
// src/forms/DateRangePickerWithYearMonthNavigation.js